import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { USER_SERVICES_METHOD } from "services/commonService";

const SLICE = "AdminConsole";

const initialState: any = {
  userPermissions: [],
  totalRecords: 0,
  adminConsoleLoader: false
};

function isRejectedAction(action: any) {
  return action.type.endsWith("rejected");
}

export const fetchUserPermissionSummary = createAsyncThunk(
  `${SLICE}/fetchUserPermissionSummary`,
  (data: any, thunkApi) => apiRequest(USER_SERVICES_METHOD.postCorporatePermissions, data.payload, thunkApi, [])
);

export const updateEditPermissions = createAsyncThunk(`${SLICE}/updateEditPermissions`, (data: any, thunkApi) =>
  apiRequest(USER_SERVICES_METHOD.patchCorporatePermissions, data, thunkApi, [])
);

export const adminConsoleSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPermissionSummary.pending, (state, action: any) => {
        state.adminConsoleLoader = action.meta.arg.payload.pageable.page === 0;
      })
      .addCase(fetchUserPermissionSummary.fulfilled, (state, action: any) => {
        state.totalRecords = action.payload.meta.page.total;
        state.userPermissions =
          action.meta.arg.payload.pageable.page === 0
            ? action.payload.users
            : [...state.userPermissions, ...action.payload.users];
        state.adminConsoleLoader = false;
      })
      .addMatcher(isRejectedAction, (state, action) => {
        state.adminConsoleLoader = false;
      });
  }
});
export const { reset } = adminConsoleSlice.actions;
export default adminConsoleSlice.reducer;
